import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import {
  Backdrop,
  CircularProgress,
  LinearProgress,
  Paper,
} from "@mui/material";
import style from "./WorkshopAdmin.module.css";
import WorkshopMenu from "./WorkshopMenu/WorkshopMenu";
import { loadWorkshop } from "../../state/workshopSlice";

const WorkshopAdmin = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { workshopSaving, workshopLoading } = useSelector(
    (state) => state.workshops.status
  );

  useEffect(() => {
    if (id) dispatch(loadWorkshop(id));
  }, [id]);

  return (
    <>
      <Paper variant="outlined" className={style.main}>
        {/* overlay everything when a workshop is being saved */}
        <Backdrop open={workshopSaving} sx={{ zIndex: 999 }}>
          <CircularProgress color="inherit" size={100} />
        </Backdrop>
        <WorkshopMenu />
        {workshopLoading && <LinearProgress />}
        {/* Outlet will contain ViewWorkshop or EditWorkshop depending on the current route */}
        <Outlet />
      </Paper>
    </>
  );
};

export default WorkshopAdmin;
